exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".des[data-v-c850e946]{font-size:.22rem;font-family:Roboto-Medium,Roboto;font-weight:500;color:rgba(0,0,0,.85);line-height:.32rem}", ""]);

// exports
